// The shared app has responsive styles for every device. Test pages retain
// their standalone appearance.
export const getRouteAppearance = (pathname: string) => {
  const redesignEnabled = !pathname.startsWith('/test-');

  return {
    redesignEnabled,
    bodyClassName: redesignEnabled ? 'my-pc desktop-redesign' : 'my-pc',
  };
};
